import styled from "styled-components";

const ArticlesContainer = styled.div``;

export { ArticlesContainer };
